<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <form>
          <div class="my-5 offset-sm-1"> <h4>Datos personales del aspirante</h4></div>
          <div class="row">
            <div class="col-sm-4 offset-sm-1"	>
              <div class="form-group" :class="{ 'form-group--error': $v.item.name.$error }">
                <label for="aspirantName">Nombre/s (según Documento)</label>
                <input
                  type="text"
                  class="form-control"
                  id="aspirantName"
                  aria-describedby="emailHelp"
                  v-model="item.name"
                />
                  <div class="error" v-if="!$v.item.name.required">Campo requerido</div>
                  <div class="error" v-if="!$v.item.name.letters">El nombre no debe contener números.</div>
                  <!-- <div class="has-error" v-if="!$v.item.name.minLength">El nombre debe tener al menos {{$v.item.name.$params.minLength.min}} caracteres.</div> -->
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.lastName.$error }">
                <label for="aspirantLastName">Apellido/s (según Documento)</label>
                <input
                  type="text"
                  class="form-control"
                  id="aspirantLastName"
                  aria-describedby="emailHelp"
                  v-model="item.lastName"
                />
                  <div class="error" v-if="!$v.item.lastName.required">Campo requerido</div>
                  <div class="error" v-if="!$v.item.lastName.letters">El apellido no debe contener números.</div>
              </div>
            </div>
            <div class="col-sm-3">
            <div class="form-group" :class="{ 'form-group--error': $v.item.genderSelected.$error }">
                <div class="fg-line">
                    <label>Género:</label>
                    <div class="select">
                        <select v-model="item.genderSelected" id="genderCode" name="genderSelected" class="form-control"><!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="gender of genders" :key="gender.code" :value="gender">{{ gender.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.genderSelected.required">Seleccione una opción</div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.documentNumber.$error }">
                <label for="aspirantDni">DNI del Estudiante</label>
                <input
                  type="text"
                  class="form-control"
                  id="aspirantDni"
                  aria-describedby="emailHelp"
                  v-model="item.documentNumber"
                />
                  <div class="error" v-if="!$v.item.documentNumber.required">Campo requerido</div>
                  <div class="error" v-if="!$v.item.documentNumber.dni">El campo no debe contener caracteres especiales</div>
                  <div class="error" v-if="!$v.item.documentNumber.minLength || !$v.item.documentNumber.maxLength ">Debe ingresar un DNI válido</div>
              </div>
            </div>
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.cuilNumber.$error }">
                <label for="aspirantCuil">CUIL</label>
                <input
                  type="text"
                  class="form-control"
                  id="aspirantCuil"
                  aria-describedby="emailHelp"
                  v-model="item.cuilNumber"
                />
                  <div class="error" v-if="!$v.item.cuilNumber.required">Campo requerido</div>
                  <div class="error" v-if="!$v.item.cuilNumber.dni">Debe ingresar el CUIL sin guiones</div>
                  <div class="error" v-if="!$v.item.cuilNumber.minLength || !$v.item.cuilNumber.maxLength ">Debe ingresar un CUIL válido</div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.birthDate.$error }">
                <label for="aspirantBirthday">Fecha de nacimiento</label>
                <div class="row">
                  <div class="col-md-12">
                    <date-picker v-model="item.birthDate" :config="options"></date-picker>
                  </div>
                </div>
                  <div class="error" v-if="!$v.item.birthDate.required">Campo requerido</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
            <div class="form-group" :class="{ 'form-group--error': $v.item.nationalitySelected.$error }">
                <div class="fg-line">
                    <label>Nacionalidad:</label>
                    <div class="select">
                        <select v-model="item.nationalitySelected" id="countryCode" name="countrySelected" class="form-control"> <!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="citizenship of countries" :key="citizenship.code_iso_alfa3" :value="citizenship">{{ citizenship.citizenship }}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.nationalitySelected.required">Campo requerido</div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
            <div class="col-sm-3 offset-sm-1">
            <div class="form-group" :class="{ 'form-group--error': $v.item.countrySelected.$error }">
                <div class="fg-line">
                    <label>País de Nacimiento:</label>
                    <div class="select">
                        <select v-model="item.countrySelected" @change="getProvinces(item.countrySelected)" id="countryCode" name="countrySelected" class="form-control"><!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="country of countries" :key="country.code_iso_alfa3" :value="country">{{ country.common_name}}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.countrySelected.required">Campo requerido</div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
            <div class="col-sm-3">
            <div class="form-group" :class="{ 'form-group--error': $v.item.provinceSelected.$error }">
                <div class="fg-line">
                    <label>Provincia de Nacimiento:</label>
                    <div class="select">
                        <select v-model="item.provinceSelected" id="ProvinceCode" name="provinceSelected" class="form-control"> <!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="province of provinces" :key="province.code_iso" :value="province">{{ province.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.provinceSelected.required">Campo requerido</div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.townOfBirth.$error }">
                <label for="aspirantTownOfBirth">Ciudad de Nacimiento</label>
                <input
                  type="text"
                  class="form-control"
                  id="aspirantTownOfBirth"
                  aria-describedby="emailHelp"
                  v-model="item.townOfBirth"
                />
                  <div class="error" v-if="!$v.item.townOfBirth.required">Campo requerido</div>
              </div>
            </div>
            <div class="col-sm-3 offset-sm-1">
            <div class="form-group" :class="{ 'form-group--error': $v.item.bloodGroupSelected.$error }">
                <div class="fg-line">
                    <label>Grupo Sanguíneo:</label>
                    <div class="select">
                        <select v-model="item.bloodGroupSelected" id="bloodGrupCode" name="bloodGroupSelected" class="form-control"><!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="bloodG of bloodGroups" :key="bloodG.code" :value="bloodG">{{ bloodG.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.bloodGroupSelected.required">Campo requerido</div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
            <div class="col-sm-3">
            <div class="form-group" :class="{ 'form-group--error': $v.item.bloodFactorSelected.$error }">
                <div class="fg-line">
                    <label>Factor Sanguíneo:</label>
                    <div class="select">
                        <select v-model="item.bloodFactorSelected" id="bloodFactorCode" name="bloodFactorSelected" class="form-control"><!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="bloodF of bloodFactors" :key="bloodF.code" :value="bloodF">{{ bloodF.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.bloodFactorSelected.required">Campo requerido</div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
          </div>

          <!-- ############################ DATOS DE DOMICILIO ACTUAL   ############################# -->
          <div class="my-5"></div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.actualCountrySelected.$error }">
                <div class="fg-line">
                    <label>País actual:</label>
                    <div class="select">
                        <select v-model="item.actualCountrySelected" id="countryCode" @change="getActualProvinces(item.actualCountrySelected)" name="actualCountrySelected" class="form-control"><!-- v-validate="'required'"-->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="country of actualCountries" :key="country.code_iso_alfa3" :value="country">{{ country.common_name }}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.actualCountrySelected.required">Campo requerido</div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
            <div class="col-sm-3 offset-sm-1" >
            <div class="form-group" :class="{ 'form-group--error': $v.item.actualProvinceSelected.$error }">
                <div class="fg-line">
                    <label>Provincia actual:</label>
                    <div class="select">
                        <select v-model="item.actualProvinceSelected" id="ProvinceCode" name="actualProvinceSelected" class="form-control"> <!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="province of actualProvinces" :key="province.code_iso" :value="province">{{ province.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.actualProvinceSelected.required">Campo requerido</div>

                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.location.$error }">
                <label for="city">Ciudad</label>
                <input
                  type="text"
                  class="form-control"
                  id="city"
                  aria-describedby="emailHelp"
                  v-model="item.location"
                />
                <div class="error" v-if="!$v.item.location.required">Campo requerido</div>

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.postalCode.$error }">
                <label for="postalCode">Código postal</label>
                <input
                  type="text"
                  class="form-control"
                  id="postalCode"
                  aria-describedby="emailHelp"
                  v-model="item.postalCode"
                />
                <div class="error" v-if="!$v.item.postalCode.required">Campo requerido</div>

              </div>
            </div>
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group">
                <label for="neighborhood">Barrio</label>
                <input
                  type="text"
                  class="form-control"
                  id="neighborhood"
                  aria-describedby="emailHelp"
                  v-model="item.neighborhood"
                />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.street.$error }">
                <label for="street">Calle</label>
                  <input
                    type="text"
                    class="form-control"
                    id="street"
                    aria-describedby="emailHelp"
                    v-model="item.street"
                  />
                  <div class="error" v-if="!$v.item.street.required">Campo requerido</div>

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1" :class="{ 'form-group--error': $v.item.streetNumber.$error }">
              <div class="form-group">
                <label for="streetNumber">Número de calle</label>
                <input
                  type="text"
                  class="form-control"
                  id="streetNumber"
                  aria-describedby="emailHelp"
                  v-model="item.streetNumber"
                />
                <div class="error" v-if="!$v.item.streetNumber.required">Campo requerido</div>
              </div>
            </div>
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group">
                <label for="floorNumber">Piso</label>
                <input
                  type="text"
                  class="form-control"
                  id="floorNumber"
                  aria-describedby="emailHelp"
                  v-model="item.floorNumber"
                />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="department">Departamento</label>
                <input
                  type="text"
                  class="form-control"
                  id="department"
                  aria-describedby="emailHelp"
                  v-model="item.department"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group">
                <label for="building">Edificio</label>
                <input
                  type="text"
                  class="form-control"
                  id="building"
                  aria-describedby="emailHelp"
                  v-model="item.building"
                />
              </div>
            </div>
            <div class="col-sm-6 offset-sm-1">
              <div class="form-group">
                <label for="comment">Comentario</label>
                <textarea maxlength="150" class="form-control" aria-label="With textarea" v-model="item.comment"></textarea>
              </div>
            </div>
          </div>

          <!-- ############################ CONDICIÓN DE DISCAPACIDAD   ############################# -->
          <div class="my-5" />
          <div class="row">
            <div class="col-sm-6 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.hasDisability.$error }">
                <label style="margin-right: 1.5rem;">
                  ¿Tiene alguna condición de discapacidad que necesite requerimiento de acceso?
                </label>

                <div class="radio">
                  <label>
                    <input
                      type="radio"
                      v-model="item.hasDisability"
                      v-bind:value="false"
                    >
                      <i class="input-helper" />
                      No
                  </label>
                </div>

                <div class="radio">
                  <label>
                    <input
                      type="radio"
                      v-model="item.hasDisability"
                      v-bind:value="true"
                    >
                      <i class="input-helper" />
                      Sí
                  </label>
                </div>

                <div class="error" v-if="!$v.item.hasDisability.required">Campo requerido</div>
              </div>
            </div>

            <div class="col-sm-6 offset-sm-1" v-if="item.hasDisability">
              <div class="form-group" :class="{ 'form-group--error': $v.item.disabilityDetail.$error }">
                <label for="aspirantDisabilityDetail">Condición de discapacidad</label>
                <textarea maxlength="150" class="form-control" aria-label="With textarea" id="aspirantDisabilityDetail" v-model="item.disabilityDetail"/>
                <div class="error" v-if="!$v.item.disabilityDetail.requiredIf">Campo requerido</div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTPFront } from '../../share';
import { validationMixin } from 'vuelidate'
import { required, minLength,maxLength, requiredIf } from 'vuelidate/lib/validators'
import {letters,dni} from '../../utils/validations'
import { mapGetters } from "vuex";


export default {
  props: ["clickedNext", "currentStep"],
  mixins: [validationMixin],
  data() {
    return {
      item: {
        name: '',
        lastName: '',
        documentNumber: '',
        cuilNumber: '',
        birthDate: new Date(),
        nationalitySelected:'',
        countrySelected: '',
        provinceSelected: '',
        townOfBirth: '',
        bloodGroupSelected: '',
        bloodFactorSelected: '',
        hasDisability: false,
        disabilityDetail: '',
        genderSelected: '',
        location: '',
        postalCode: '',
        neighborhood: '',
        street: '',
        streetNumber: '',
        floorNumber: '',
        department: '',
        building: '',
        actualCountrySelected: '',
        actualProvinceSelected: '',
        comment: '',
      },
      citizenships: null,
      countries:null,
      actualCountries:null,
      actualProvinces:null,
      provinces:null,
      bloodGroups:null,
      bloodFactors:null,
      genders:null,
      options: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        locale:"es",
        widgetPositioning: {
          vertical: "bottom",
        },
      },
    };
  },
  validations: {
    item: {
      name: {
        required,
        letters
      },
      lastName: {
        required,
        letters
      },
      genderSelected:{
        required
      },
      documentNumber:{
        required,
        dni,
        minLength : minLength(7),
        maxLength : maxLength(15)
      },
      cuilNumber:{
        required,
        dni,
        minLength : minLength(11),
        maxLength : maxLength(15)
      },
      birthDate:{
        required
      },
      nationalitySelected:{
        required
      },
      countrySelected:{
        required
      },
      provinceSelected:{
        required
      },
      townOfBirth:{
        required
      },
      bloodGroupSelected:{
        required
      },
      bloodFactorSelected:{
        required
      },
      hasDisability: {
        required
      },
      disabilityDetail: {
        requiredIf: requiredIf('hasDisability')
      },
      actualCountrySelected:{
        required
      },
      actualProvinceSelected:{
        required
      },
      location: {
        required
      },
      postalCode:{
        required
      },
      street:{
        required
      },
      streetNumber:{
        required
      }
    }
  },
  created() {
    //this.getCountries();
    this.getData();
    this.getBloodGroups();
    this.getBloodFactors();
    this.getGenders();
  },
  computed:{
    ...mapGetters(["getLevel"]),
  },
  watch: {
    $v: {
      handler: function (val) {
        if (!val.$invalid) {
          // Formulario válido
          this.$store.commit('setStepOneData', this.item)
          this.$emit("can-continue", { value: true });
        } else {
          this.$emit("can-continue", { value: false });
        }
      },
      deep: true,
    },
    clickedNext(val) {
      if (val === true) {
        this.$v.item.$touch();
      }
    },
    currentStep(){
      if(!this.$v.$invalid){
        this.$emit("can-continue", { value: true });
      }
    }
  },
  mounted() {
    if (!this.$v.$invalid) {
      this.$store.commit('setStepTwoData', this.item)
      this.$emit("can-continue", { value: true });
    } else {
      this.$emit("can-continue", { value: false });
    }
  },
  methods: {
    async getCountries() {
      this.actualCountries=this.countries = (await HTTPFront.get('/getCountries')).data
    },
    getProvinces(countrySelected){
      HTTPFront.get('/getProvincesByCountry/'+ countrySelected.code_iso_alfa3)
      .then(res => {
        this.provinces = res.data;
      })
    },
    getBloodGroups() {
      HTTPFront.get('/getBloodGroups')
      .then(res => {
        this.bloodGroups = res.data;
      })
    },
    getBloodFactors() {
      HTTPFront.get('/getBloodFactors')
      .then(res => {
        this.bloodFactors = res.data;
      })
    },
    getGenders() {
      HTTPFront.get('/getGenders/'+this.getLevel)
      .then(res => {
        this.genders = res.data;
      })
    },
    async getData() {
      await this.getCountries();
      this.item.actualCountrySelected = await this.countries.find(country => country.code_iso_alfa3 === 'ARG');
      await this.getActualProvinces(this.item.actualCountrySelected);
      this.item.actualProvinceSelected = await this.actualProvinces.find(province => province.code_iso === 'AR-X');
    },
    async getActualProvinces(countrySelected) {
      this.actualProvinces = (await HTTPFront.get('/getProvincesByCountry/'+ countrySelected.code_iso_alfa3)).data
    }
  }
};
</script>
<style>
.error{
  color:red;
}

textarea{
  max-height: 150px;
}
</style>